export enum ChangePasswordFields {
    NewPassword = 'newPassword',
    ConfirmNewPassword = 'confirmNewPassword',
}

export type ChangePasswordFormValues = Record<ChangePasswordFields, string>;
